import { render } from "./StepOne70_77.vue?vue&type=template&id=9db08498"
import script from "./StepOne70_77.vue?vue&type=script&lang=js"
export * from "./StepOne70_77.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__